var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card simple-card p-sm-0" },
    [
      _c("div", { staticClass: "d-md-block card__video-wrapper" }, [
        _c(
          "a",
          {
            staticClass: "card__anchor-wrapper",
            attrs: { href: _vm.processedVideo.url },
            on: { click: _vm.checkForTrustedClick }
          },
          [_c("media-video", { attrs: { video: _vm.processedVideo } })],
          1
        )
      ]),
      _vm._v(" "),
      _c("simple-content", { attrs: { content: _vm.processedVideo } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }